import { FlagColor } from "./CalendarData";

export class TblBidList {
  id?: number;
  fieldId?: string;
  empNum?: number;
  lineData?: BidListLineData[] = [];
}

export class BidListLineData {
  lineNumber: number;
  faPositions: any;
  flagColor: string;
  flagColorArray: FlagColor[];
  isFreezeLine: boolean;
  insertLineInfo: InsertLineInfo[];
  markerTextInfo: MarkerTextInfo[];
  isAboveInsert: boolean;
  isBelowInsert: boolean;
  freezeLineInfo: FreezeLineInfo[];
  bidLineOrder?: number;
  bidLineOrderInfo?: BidLineOrderInfo[];
  markerText?: string;
  isHiddenBidList?: boolean;
}
export class InsertLineInfo {
  position: string;
  isAbove: boolean;
  isBelow: boolean;
}
export class FreezeLineInfo {
  position: string;
  isFrozen: boolean;
}
export class MarkerTextInfo {
  position: string;
  markerText: string;
}
export class BidLineOrderInfo {
  position: string;
  order: number;
}
